import $ from "jquery";
import { throttle } from "throttle-debounce";
/* import hoverEffect from 'hover-effect'; */
import { Color } from "./color";
//import "jquery-mousewheel";

$.easing = Object.assign({}, $.easing, {
  // swing: function(x, t, b, c, d) {
  //   return jQuery.easing[$.easing.def](x, t, b, c, d);
  // },
  // easeInQuad: function(x, t, b, c, d) {
  //   return c * (t /= d) * t + b;
  // },
  // easeOutQuad: function(x, t, b, c, d) {
  //   return -c * (t /= d) * (t - 2) + b;
  // },
  // easeInOutQuad: function(x, t, b, c, d) {
  //   if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
  //   return (-c / 2) * (--t * (t - 2) - 1) + b;
  // },
  // easeInCubic: function(x, t, b, c, d) {
  //   return c * (t /= d) * t * t + b;
  // },
  // easeOutCubic: function(x, t, b, c, d) {
  //   return c * ((t = t / d - 1) * t * t + 1) + b;
  // },
  // easeInOutCubic: function(x, t, b, c, d) {
  //   if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b;
  //   return (c / 2) * ((t -= 2) * t * t + 2) + b;
  // },
  // easeInQuart: function(x, t, b, c, d) {
  //   return c * (t /= d) * t * t * t + b;
  // },
  easeOutQuart: function(x, t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  },
  // easeInOutQuart: function(x, t, b, c, d) {
  //   if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
  //   return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
  // },
  // easeInQuint: function(x, t, b, c, d) {
  //   return c * (t /= d) * t * t * t * t + b;
  // },
  // easeOutQuint: function(x, t, b, c, d) {
  //   return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  // },
  // easeInOutQuint: function(x, t, b, c, d) {
  //   if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t * t + b;
  //   return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
  // },
  // easeInSine: function(x, t, b, c, d) {
  //   return -c * Math.cos((t / d) * (Math.PI / 2)) + c + b;
  // },
  // easeOutSine: function(x, t, b, c, d) {
  //   return c * Math.sin((t / d) * (Math.PI / 2)) + b;
  // },
  // easeInOutSine: function(x, t, b, c, d) {
  //   return (-c / 2) * (Math.cos((Math.PI * t) / d) - 1) + b;
  // },
  // easeInExpo: function(x, t, b, c, d) {
  //   return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
  // },
  // easeOutExpo: function(x, t, b, c, d) {
  //   return t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
  // },
  // easeInOutExpo: function(x, t, b, c, d) {
  //   if (t == 0) return b;
  //   if (t == d) return b + c;
  //   if ((t /= d / 2) < 1) return (c / 2) * Math.pow(2, 10 * (t - 1)) + b;
  //   return (c / 2) * (-Math.pow(2, -10 * --t) + 2) + b;
  // },
  // easeInCirc: function(x, t, b, c, d) {
  //   return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
  // },
  // easeOutCirc: function(x, t, b, c, d) {
  //   return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
  // },
  // easeInOutCirc: function(x, t, b, c, d) {
  //   if ((t /= d / 2) < 1) return (-c / 2) * (Math.sqrt(1 - t * t) - 1) + b;
  //   return (c / 2) * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
  // },
  // easeInElastic: function(x, t, b, c, d) {
  //   var s = 1.70158;
  //   var p = 0;
  //   var a = c;
  //   if (t == 0) return b;
  //   if ((t /= d) == 1) return b + c;
  //   if (!p) p = d * 0.3;
  //   if (a < Math.abs(c)) {
  //     a = c;
  //     var s = p / 4;
  //   } else var s = (p / (2 * Math.PI)) * Math.asin(c / a);
  //   return (
  //     -(
  //       a *
  //       Math.pow(2, 10 * (t -= 1)) *
  //       Math.sin(((t * d - s) * (2 * Math.PI)) / p)
  //     ) + b
  //   );
  // },
  // easeOutElastic: function(x, t, b, c, d) {
  //   var s = 1.70158;
  //   var p = 0;
  //   var a = c;
  //   if (t == 0) return b;
  //   if ((t /= d) == 1) return b + c;
  //   if (!p) p = d * 0.3;
  //   if (a < Math.abs(c)) {
  //     a = c;
  //     var s = p / 4;
  //   } else var s = (p / (2 * Math.PI)) * Math.asin(c / a);
  //   return (
  //     a * Math.pow(2, -10 * t) * Math.sin(((t * d - s) * (2 * Math.PI)) / p) +
  //     c +
  //     b
  //   );
  // },
  // easeInOutElastic: function(x, t, b, c, d) {
  //   var s = 1.70158;
  //   var p = 0;
  //   var a = c;
  //   if (t == 0) return b;
  //   if ((t /= d / 2) == 2) return b + c;
  //   if (!p) p = d * (0.3 * 1.5);
  //   if (a < Math.abs(c)) {
  //     a = c;
  //     var s = p / 4;
  //   } else var s = (p / (2 * Math.PI)) * Math.asin(c / a);
  //   if (t < 1)
  //     return (
  //       -0.5 *
  //         (a *
  //           Math.pow(2, 10 * (t -= 1)) *
  //           Math.sin(((t * d - s) * (2 * Math.PI)) / p)) +
  //       b
  //     );
  //   return (
  //     a *
  //       Math.pow(2, -10 * (t -= 1)) *
  //       Math.sin(((t * d - s) * (2 * Math.PI)) / p) *
  //       0.5 +
  //     c +
  //     b
  //   );
  // },
  // easeInBack: function(x, t, b, c, d, s) {
  //   if (s == undefined) s = 1.70158;
  //   return c * (t /= d) * t * ((s + 1) * t - s) + b;
  // },
  // easeOutBack: function(x, t, b, c, d, s) {
  //   if (s == undefined) s = 1.70158;
  //   return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  // },
  // easeInOutBack: function(x, t, b, c, d, s) {
  //   if (s == undefined) s = 1.70158;
  //   if ((t /= d / 2) < 1)
  //     return (c / 2) * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
  //   return (c / 2) * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
  // },
  // easeInBounce: function(x, t, b, c, d) {
  //   return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
  // },
  // easeOutBounce: function(x, t, b, c, d) {
  //   if ((t /= d) < 1 / 2.75) {
  //     return c * (7.5625 * t * t) + b;
  //   } else if (t < 2 / 2.75) {
  //     return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
  //   } else if (t < 2.5 / 2.75) {
  //     return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
  //   } else {
  //     return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
  //   }
  // },
  // easeInOutBounce: function(x, t, b, c, d) {
  //   if (t < d / 2)
  //     return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * 0.5 + b;
  //   return (
  //     jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b
  //   );
  // },
});

export class SliderNavigation {
  constructor(params) {
    this.params = $.extend(
      {
        containerSelector: ".msnt-slides",
        fadeThrottle: 350,
      },
      params
    );

    this.firstRun = true;

    this.autoscroll = false;
    this._lastScroll = 0;
    this._scrollDir = 1;
    this.playTimeout = null;

    this.scrollActive = true;

    this.touchStart = 0;
    this.touchEnd = 0;

    this.scrollTimeout = null;

    this.initialSlide = true;

    this.slideTimeoutId = null;
    this.slideBgTimeout = 10000;
    this.blurBgId = null;
    this.blurBgTimeout = 150;

    this.animateValueTime = 2000;

    this.values = [];
    this.maxValues = 5;

    this.lastEventAt = 0;
    this.clearValueThreshold = 100;

    this.readyToAcceptNewScroll = true;

    this.$window = $(window);
    this.$container = $(this.params.containerSelector);

    if (!this.$container.length) return;

    $("html, body").css({ overflow: "hidden" });

    this.$container.removeClass("transition");

    this.$slides = this.$container.children();

    this.slideHashes = [
      ...this.$slides.map((index, el) => $(el).data("slide")),
    ];

    this.$nextSlide = $(".nextSlide");

    this.init();
    this.$container.trigger("msnt-slider-load");

    this.imagePromise = null;
  }

  init() {
    this.$slides.each((i, slide) => {
      //this._prepareSlide($(slide));
      this._getIcons($(slide));
      setTimeout(() => {
        slide.classList.add("mobile-ready");
      }, 100);
    });

    this._detectAutoScroll();

    this.reload();

    this._initEvents();

    //this._setTransitionEffects();
  }

  reload() {
    const hash = window.location.hash.replace("#", "");

    const index = hash ? this.slideHashes.indexOf(hash) : 0;

    this.currentIndex = index;
    this.slideHeight = 0;
    this.$currentSlide = this.$slides.eq(index);

    this._initVars();

    // if (window.matchMedia("(pointer: fine)").matches) {
    //   this._scrollTo(this.$currentSlide, 0);
    // }
    this.changeSlide(this.$currentSlide);
  }

  changeSlide($slide) {
    this.$slides
      .filter(".msnt-slide_current")
      .removeClass("msnt-slide_current");

    $slide.addClass("mobile-visible");
    $slide.prevAll().addClass("mobile-visible");
    $slide.nextAll().removeClass("mobile-visible");

    this._stopIconsAnimation(this.$currentSlide);

    this.$currentSlide = $slide;

    setTimeout(
      () => {
        this._playIconsAnimation($slide);
        this.firstRun = false;
      },
      this.firstRun ? 500 : 10
    );

    setTimeout(() => {
      this.$currentSlide.addClass("msnt-slide_current");
      this._prepareSlide(this._getPrevSlide());
      this._prepareSlide(this._getNextSlide());
      this.scrollActive = true;
    }, 10);

    this._prepareSlide(this.$currentSlide);

    window.location.hash = this.$currentSlide.data("slide");
    this.$container.trigger("msnt-hash-changed");

    clearTimeout(this.slideTimeoutId);
    this.$window.trigger("mousemove");

    this._animateTitle(this.$currentSlide.find(".msnt-slide_title--animated"));
  }

  changeSlideBg() {
    clearTimeout(this.slideTimeoutId);

    if (!this.$currentSlide.data("init")) {
      return;
    }

    this.slideTimeoutId = setTimeout(() => {
      let count = 0;
      if (this.$currentSlide.data("count")) {
        count = this.$currentSlide.data("count");
      } else {
        this.$currentSlide.data("count", count);
      }

      if (this.autoscroll && count >= 1) {
        this.fadeSlide(this._getNextSlide());
        this.$currentSlide.data("count", 0);
      } else {
        if (this.autoscroll) {
          this.$currentSlide.data("count", count + 1);
        }

        this.imagePromise = this._loadImage(this.$currentSlide);

        this.$currentSlide
          .addClass("msnt-slide__blured")
          .removeClass("msnt-slide_current");

        this.imagePromise.then((image) => {
          this.blurBgId = setTimeout(() => {
            this.$currentSlide
              .find(".msnt-slide_bg-image")
              .css("background-image", "url(" + image.src + ")")
              .addClass("loaded");

            this.$currentSlide
              .removeClass("msnt-slide__blured")
              .addClass("msnt-slide_current");

            setTimeout(() => {
              this.changeSlideBg();
            }, 10);
          }, this.blurBgTimeout);
        });
      }
    }, this.slideBgTimeout);
  }

  fadeSlide($slide, callback) {
    this._stopIconsAnimation(this.$currentSlide);
    this.$container.stop().fadeTo(750, 0, () => {
      this._scrollTo($slide, 0);
      this._playIconsAnimation($slide);
      this.$currentSlide.removeClass("msnt-slide_current");
      this.$currentSlide = $slide;

      if (typeof callback == "function") {
        const autoscroll = this.autoscroll;
        this.autoscroll = false;
        callback.call(this);

        this.autoscroll = autoscroll;
      }

      if (this.$currentSlide[0] === $slide[0]) {
        this.$currentSlide.addClass("msnt-slide_delay");
        setTimeout(() => {
          this.$currentSlide
            .removeClass("msnt-slide_delay")
            .addClass("msnt-slide_current");
        }, 500);
        this.$container.delay(500).fadeTo(750, 1);
      } else {
        this.$container.fadeTo(750, 1);
      }
    });
  }

  getFirstSlide() {
    return this.$slides.first();
  }

  getLastSlide() {
    return this.$slides.last();
  }

  next() {
    let newIndex = this.currentIndex + 1;

    if (newIndex >= this.$slides.length) {
      newIndex = 0;
    }

    this.currentIndex = newIndex;
    this.$container.scrollTop(newIndex * this.slideHeight);
    this.changeSlide(this.$slides.eq(newIndex));
  }

  _getIcons($slide) {
    $slide = $slide || this.$currentSlide;

    var icons = $slide.data("icons");

    if (!icons) {
      icons = [];
      const $animations = $slide.find(".msnt-slide-item_image svg");
      $animations.each(function(i, elem) {
        icons.push(new Vivus(elem.id, { start: "manual" }));
      });

      $slide.data("icons", icons);
    }

    return icons;
  }

  _playIconsAnimation($slide) {
    const speed = 3;

    $slide = $slide || this.$currentSlide;

    if ($slide.data("play") == 1) {
      return;
    }

    $slide.data("play", 1);

    clearTimeout(this.playTimeout);

    this.playTimeout = setTimeout(() => {
      var icons = this._getIcons($slide);
      for (var i = 0; i < icons.length; i++) {
        icons[i].play(speed);
        $(icons[i].el).css("opacity", 1);
      }
    }, 100);

    $slide.find(".msnt-counter_target").each((i, e) => {
      if (!e.dataset.animate) {
        e.dataset.animate = 1;
        this._animateValue(
          e,
          e.dataset.decimal
            ? parseFloat(e.dataset.start)
            : parseInt(e.dataset.start),
          e.dataset.decimal
            ? parseFloat(e.dataset.value)
            : parseInt(e.dataset.value),
          this.animateValueTime,
          !!e.dataset.decimal
        );

        $(e).css("opacity", 1);
      }
    });
  }

  _stopIconsAnimation($slide, reset) {
    $slide = $slide || this.$currentSlide;
    reset = !!reset || false;

    if ($slide.data("play") != 1) {
      $slide.data("play", 0);
      return;
    }

    $slide.data("play", 0);

    clearTimeout(this.playTimeout);

    var icons = this._getIcons($slide);

    for (var i = 0; i < icons.length; i++) {
      var icon = icons[i];
      icon.stop();
      if (reset) {
        icon.reset();
      }
    }
  }

  _scrollToMob($slide) {
    if (!$slide.length) return;

    this.changeSlide($slide);
  }

  _scrollTo($slide, time = 1500) {
    if (!$slide.length) {
      this.scrollActive = true;
      return;
    }

    if (!this.scrollActive) {
      return;
    }

    this.scrollActive = false;

    const index = this.$slides.index($slide);

    this.$container.animate(
      {
        scrollTop: index * this.$container.height(),
      },
      time,
      "easeOutQuart",
      //"linear",
      () => {
        // this.$container.removeClass('transition')
        //this._checkCurrentSlide();
        this.changeSlide($slide);

        // setTimeout(() => {
        //   this._lastScroll = this.$container.scrollTop();
        //   this.$container.removeClass("lock-scroll");
        // }, 10);
      }
    );
  }

  _prepareSlide($slide) {
    if (!$slide.length) {
      return;
    }

    if (!$slide.data("init")) {
      $slide.data("init", 1);

      this._loadImage($slide).then((image) => {
        $slide
          .find(".msnt-slide_bg-image")
          .css("background-image", "url(" + image.src + ")")
          .addClass("loaded");
      });

      // animate initial slide
      if (this.initialSlide) {
        this.initialSlide = false;

        this.$container.delay(0).animate({ opacity: 1 }, 0);

        setTimeout(() => {
          this._stopIconsAnimation($slide);
          this._playIconsAnimation($slide);
        }, 600);
      }
    }
  }

  _animateTitle($title) {
    if (!$title.length || $title.data("animated")) {
      return;
    }

    $title.each((i, el) => {
      const $el = $(el);
      const isRtl = $el.data("dir") === "rtl";

      $el.data("animated", 1);

      const $container = $("<span>").css({
        position: "absolute",
        width: "100%",
        height: "120%",
        left: isRtl ? "auto" : 0,
        right: isRtl ? 0 : "auto",
        top: "-10%",
      });

      const $box = $("<span>").css({
        position: "absolute",
        width: "calc(100% + 20px)",
        height: "100%",
        background: "#fff",
        left: isRtl ? "auto" : "-10px",
        right: isRtl ? "-10px" : "auto",
        top: 0,
        transform: "skewX(-20deg) scale(0, 1)",
        "will-change": "transform",
      });

      $el.append($container.append($box));

      setTimeout(() => {
        $box.animate(
          { transform: "translate3d(0px, 0px, 0px)" },
          {
            duration: 800,
            progress: (element, progress, left) => {
              if (progress <= 0.5) {
                $box.css({
                  "-webkit-transform":
                    "translate3d(0px, 0px, 0px) skew(-20deg, 0deg) scale(" +
                    progress * 2 +
                    ", 1)",

                  "transform-origin": isRtl ? "right center" : "left center",
                });
              } else {
                $box.css({
                  "-webkit-transform":
                    "translate3d(0px, 0px, 0px) skew(-20deg, 0deg) scale(" +
                    (1 - (progress - 0.5) * 2) +
                    ", 1)",

                  "transform-origin": isRtl ? "left center" : "right center",
                });

                $el.css("color", "#fff");
              }
            },
            complete: () => {
              $container.remove();
            },
          }
        );
      }, 700);
    });
  }

  _loadImage($slide) {
    var path =
      "/design/src/img/v2/" +
      (window.MSNTConfig.imagesPath ? window.MSNTConfig.imagesPath : "home/") +
      $slide.data("slide") +
      "/" +
      this._getSlideDir($slide) +
      this._getSlideImage($slide);

    return new Promise((resolve, reject) => {
      var image = new Image();

      image.onload = () => {
        resolve(image);
      };

      image.src = path;
    });
  }

  _getSlideDir($slide) {
    if (this.isSmall) {
      return "small/";
    } else if (
      this.isMedium &&
      $slide.find(".msnt-slide_bg").data("images-t")
    ) {
      return "medium/";
    }

    return "";
  }

  _getSlideImage($slide) {
    const $container = $slide.find(".msnt-slide_bg");
    let images = false;

    if (this.isSmall) {
      const sImages = $container.data("images-m");
      if (sImages) {
        images = sImages.split(",");
      }
    } else if (this.isMedium) {
      const sImages = $container.data("images-t");
      if (sImages) {
        images = sImages.split(",");
      }
    }

    if (!images) {
      images = $container.data("images").split(",");
    }

    let index = 0;

    if ($slide.data("index") !== undefined) {
      index = 1 + parseInt($slide.data("index"));
      if (index >= images.length) {
        index = 0;
      }
      $slide.data("index", index);
    } else {
      index = Math.floor(Math.random() * images.length);
      $slide.data("index", index);
    }

    let backgrounds = $container.data("backgrounds");

    if (backgrounds) {
      backgrounds = backgrounds.split(",");
    }

    $container.data(
      "bg-color",
      backgrounds ? backgrounds[index] || false : false
    );

    return images[index];
  }

  _initVars() {
    // this.slideHeight = this.$slides
    //   .eq(0)
    //   .find(".msnt-slides_wrapper")
    //   .height();

    this.slideHeight = window.innerHeight;

    /*this.$slides.css({
      height: this.slideHeight * 2,
      'margin-top': -this.slideHeight,
    });*/

    //this.$slides.find('.msnt-slides_wrapper').css({ height: this.slideHeight });

    this.isSmall = this.$window.width() < 1024;
    this.isMedium = !this.isSmall && this.$window.width() <= 1366;

    this.transparentBorder = this.$window.width() < 768;
  }

  _initEvents() {
    const _this = this;

    new SwipeDetector({
      element: _this.$container[0],
      upCallback: () => {
        _this._scrollToMob(_this.$currentSlide.next());
      },
      downCallback: () => {
        _this._scrollToMob(_this.$currentSlide.prev());
      },
    });

    _this.$container.on("touchstart", (event) => {
      // if (!_this.scrollActive) return;
      _this.touchStart = event.originalEvent.touches[0].clientY;
      _this.startScroll = _this.$container.scrollTop();
    });

    this.$container.on("touchmove", (event) => {
      // if (!_this.scrollActive || this.touchStart === 0) return;
      _this.touchEnd = event.originalEvent.touches[0].clientY;

      const diff =
        this.touchStart - event.originalEvent.changedTouches[0].clientY;

      if (diff > 0) {
        this.$currentSlide
          .next()
          .addClass("dragging")
          .css({
            transform: `translateY(${diff * -1}px)`,
          });
      } else {
        this.$currentSlide
          .addClass("dragging")
          .css(
            "transform",
            `translateY(${(this.$container.height() + diff) * -1}px)`
          );
      }
    });

    // _this.$container.on("touchstart", (e) => {
    //   e.stopPropagation();
    //   _this.touchStartPoint = _this.$container.scrollTop();
    //   _this.scrollActive = false;
    //   _this.touchStart = e.originalEvent.changedTouches[0].clientY;
    //   _this.startScroll = _this.$container.scrollTop();
    // });

    // this.$container.on("touchmove", (e) => {
    //   const diff = this.touchStart - e.originalEvent.changedTouches[0].clientY;
    //   this.$container.scrollTop(this.startScroll + diff);
    // });

    this.$container.on("touchend", (e) => {
      // if (!_this.scrollActive || _this.touchStart === 0) return;

      let $els = $([]);
      $els = $els.add(this.$currentSlide);
      $els = $els.add(this.$currentSlide.prev());
      $els = $els.add(this.$currentSlide.next());
      $els.removeClass("dragging").css("transform", "");

      if (_this.touchStart == _this.touchEnd) return;

      _this._scrollDir = _this.touchStart > _this.touchEnd ? 1 : -1;

      if (_this._scrollDir > 0) {
        _this._scrollToMob(_this.$currentSlide.next());
      } else {
        _this._scrollToMob(_this.$currentSlide.prev());
      }

      _this.touchStart = _this.touchEnd = 0;
    });

    _this.$slides.on("click", function(e) {
      return;
    });

    _this.$window
      .on(
        "mousemove",
        throttle(_this.slideBgTimeout / 10, _this.changeSlideBg.bind(_this))
      )
      .trigger("mousemove");

    $("body")
      .on("msnt-change-slide", () => {
        var hash = location.hash.replace("#", "");
        var $slide = _this.$container.find('[data-slide="' + hash + '"]');
        if ($slide.length) {
          _this._scrollTo($slide);
        }
      })
      .on("msnt-fade-slide", () => {
        var hash = location.hash.replace("#", "");
        var $slide = _this.$container.find('[data-slide="' + hash + '"]');
        if ($slide.length) {
          _this.fadeSlide($slide);
        }
      });

    $(window).on("resize", _this.reload.bind(this));

    _this.$nextSlide.on("click", () => {
      _this.fadeSlide(_this._getNextSlide());
    });
  }

  _checkCurrentSlide() {
    // if (!this.scrollActive) {
    //   return;
    // }

    if (this.$container.scrollTop() === 0) {
      $(document.body).addClass("atTop");
    } else {
      $(document.body).removeClass("atTop");
    }

    var scroll = this.$container.scrollTop() / this.$container.height();
    var top = Math.round(scroll);

    if (top < 0) {
      top = 0;
    } else if (top > this.$slides.length) {
      top = this.$slides.length;
    }

    if (top !== this.currentIndex) {
      this.currentIndex = top;
      this.changeSlide(this.$slides.eq(top));
    }

    var half = Math.round(scroll);

    if (half > this.currentIndex && this._scrollDir > 0) {
      this._stopIconsAnimation(this.$slides.eq(this.currentIndex));
      this._playIconsAnimation(this.$slides.eq(this.currentIndex + 1));
    } else if (half <= this.currentIndex && this._scrollDir < 0) {
      this._stopIconsAnimation(this.$slides.eq(half - 1));
      this._playIconsAnimation(this.$slides.eq(half));
    }
  }

  _detectAutoScroll() {
    const search = window.location.search.substr(1);

    if (!search) return;

    let hasAutoScroll = false;
    const searhcSplit = search.split("&");

    searhcSplit.forEach((item) => {
      const itemSplit = item.split("=");

      if (itemSplit[0] === "autoscroll" && itemSplit[1] === "1") {
        hasAutoScroll = true;
      }
    });

    this.autoscroll = hasAutoScroll;

    if (this.autoscroll) {
      this.$nextSlide.remove();
    } else {
      setTimeout(() => {
        this.$nextSlide.removeClass("hidden");

        setTimeout(() => {
          this.$nextSlide.addClass("animate");
        }, 300);
      }, 1000);
    }
  }

  _setTransitionEffects() {
    return;
    const index = Math.floor(this.$container.scrollTop() / this.slideHeight);
    const percent = this.$container.scrollTop() / this.slideHeight - index;
    const $slide = this.$slides.eq(index);
    const currentColor = new Color(
      $slide.find(".msnt-slide_bg").data("bg-color"),
      this.transparentBorder
    );
    const targetColor = new Color(
      $slide
        .next()
        .find(".msnt-slide_bg")
        .data("bg-color"),
      this.transparentBorder
    );

    let mixinColor = currentColor.mix(targetColor, percent);
    $(".frame-border").css("background-color", mixinColor.hex);
  }

  _setBorderColor() {
    return false;
    const currentColor = new Color(
      this.$currentSlide.find(".msnt-slide_bg").data("bg-color"),
      this.transparentBorder
    );

    $(".frame-border").css("background-color", currentColor.hex);
  }

  _getNextSlide() {
    var $next = this.$currentSlide.next();
    if (!$next.length) {
      return this.getFirstSlide();
    }
    return $next;
  }

  _getPrevSlide() {
    var $last = this.$currentSlide.prev();
    if (!$last.length) {
      return this.getLastSlide();
    }
    return $last;
  }

  _animateValue(obj, start, end, duration, decimal) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);

      if (decimal) {
        obj.innerHTML =
          Math.floor((progress * (end - start) + start) * 10) / 10;
      } else {
        obj.innerHTML = Math.floor(progress * (end - start) + start);
      }

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        obj.innerHTML = end;
      }
    };
    window.requestAnimationFrame(step);
  }
}

class SwipeDetector {
  constructor(config) {
    this.element = null;
    this.upCallback = null;
    this.downCallback = null;
    this.draw = null;

    this.deltaYHistoryLegth = 16;
    this.deltaYA1HistoryLegth = 16;
    this.deltaYA2HistoryLegth = 16;
    this.deltaYA3HistoryLegth = 16;

    this.previousPositiveDifference = 0;

    this.deltaYHistory = new Array(this.deltaYHistoryLegth).fill(0);
    this.deltaYA1History = new Array(this.deltaYA1HistoryLegth).fill(0);
    this.deltaYA2History = new Array(this.deltaYA2HistoryLegth).fill(0);
    this.deltaYA3History = new Array(this.deltaYA3HistoryLegth).fill(0);
    this.deltaYA1 = 0;
    this.deltaYA2 = 0;
    this.deltaYA3 = 0;

    this.element = config.element;
    this.upCallback = config.upCallback;
    this.downCallback = config.downCallback;
    this.draw = config.draw;

    this.wheelListener = this.wheelListener.bind(this);

    this.element.addEventListener("wheel", this.wheelListener, {
      passive: false,
    });

    this.storeZeros();
  }

  storeZeros() {
    this.storeDeltaY(0);
    requestAnimationFrame(this.storeZeros.bind(this));
  }

  storeDeltaY(deltaY) {
    this.deltaYHistory.push(deltaY);
    this.deltaYHistory.splice(0, 1);

    this.deltaYA1 = average(this.deltaYHistory);
    this.deltaYA1History.push(this.deltaYA1);
    this.deltaYA1History.splice(0, 1);

    this.deltaYA2 = average(this.deltaYA1History);
    this.deltaYA2History.push(this.deltaYA2);
    this.deltaYA2History.splice(0, 1);

    this.deltaYA3 = average(this.deltaYA2History);
    this.deltaYA3History.push(this.deltaYA3);
    this.deltaYA3History.splice(0, 1);

    const positiveDifference = this.calcPositiveDifference();

    if (this.draw) {
      this.draw([
        deltaY,
        this.deltaYA1,
        this.deltaYA2,
        this.deltaYA3,
        positiveDifference,
      ]);
    }

    if (this.previousPositiveDifference === 0 && positiveDifference > 0) {
      this.upCallback();
    }
    if (this.previousPositiveDifference === 0 && positiveDifference < 0) {
      this.downCallback();
    }

    this.previousPositiveDifference = positiveDifference;
  }

  calcPositiveDifference() {
    const diff = this.deltaYA2 - this.deltaYA3;
    if (this.deltaYA2 > 0) {
      return diff > 0 ? diff : 0;
    } else if (this.deltaYA2 < 0) {
      return diff < 0 ? diff : 0;
    } else {
      return 0;
    }
  }

  wheelListener(event) {
    this.storeDeltaY(event.deltaY);
  }

  destroy() {
    this.element.removeEventListener("wheel", this.wheelListener);
  }
}

function average(arr) {
  return arr.reduce((a, b) => a + b, 0) / arr.length;
}
